import React from 'react';
import {
    Box,
    VStack,
    HStack,
    Input,
    InputGroup,
    InputLeftElement,
    Icon,
    Text,
    IconButton,
} from '@chakra-ui/react';
import { AiOutlineSearch, AiOutlineClose } from 'react-icons/ai';
import { ReportingShellViewBaseConfig } from '../../../base';
import { InsertOverlayViewProps } from './insertOverlayProps';
import { InsertOverviewContainerProps } from '../overview';

export function createInsertOverlayView(
    config: ReportingShellViewBaseConfig & {
        Container: {
            Insert: React.FC<InsertOverviewContainerProps>;
        };
    }
): React.FC<InsertOverlayViewProps> {
    const {
        UI: {
            Application: { createErrorBoundary },
        },
        Container: { Insert: InsertOverviewContainer },
    } = config;

    const ErrorBoundary = createErrorBoundary({
        errorClass: Error,
    });

    return (props) => {
        return (
            <Box
                w="25rem" // Fixed width similar to chat overlay default
                h="full"
                position="relative"
                bg="black"
                borderLeftWidth={2}
                borderColor="whiteAlpha.300"
                {...(props.overlay.isOpen ? {} : { w: 0, overflow: 'hidden' })}
            >
                <VStack w="full" h="full" spacing={0} bg="whiteAlpha.50">
                    {/* Header */}
                    <Box
                        w="full"
                        p={4}
                        borderBottomWidth={1}
                        borderColor="whiteAlpha.200"
                    >
                        <HStack justify="space-between" align="center">
                            <Text fontSize="xl" fontWeight="bold" color="whiteAlpha.900">
                                Add to workspace
                            </Text>
                            <IconButton
                                {...props.overlay.close.button}
                                aria-label="Close"
                                icon={<Icon as={AiOutlineClose} fontSize="md" />}
                                size="sm"
                                bg="none"
                                variant="ghost"
                                color="whiteAlpha.600"
                                _hover={{ bg: 'whiteAlpha.100' }}
                                _focus={{ outline: 'none' }}
                            />
                        </HStack>
                    </Box>

                    {/* Content */}
                    <Box flex={1} w="full">
                        <InsertOverviewContainer {...props.overview} />
                    </Box>
                </VStack>
            </Box>
        );
    };
}
